import React, { Component } from "react"
import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags'
import Modal from "react-bootstrap/Modal"
import {
  Container
} from "reactstrap"
import {
  // card title
  Row,
  Col,
  // Card,
  // CardBody,
  // Table,
  Button,
  Label,
  Input
  // CardTitle
} from "reactstrap"

import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom"
//import action
import { getChartsData } from "../../store/actions"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
//import "./styles.scss"
//i18n
import { withTranslation } from "react-i18next"
import { toast } from "react-toastify"
import { resetPassword } from "../../store/session/actions"
import CrmDashBoard from "./CrmDashBoard"

//import SimpleReactValidator from "simple-react-validator"
//import  {useRef} from "react"
// const CardOject = [
//   { backgroundColor: '#0D70E2', count: '0|0|0', title: 'Lead - Todays | MTD | Overall', color: '#fff' },
//   { backgroundColor: '#f1b54c', count: '0|0|0', title: 'Unactioned - Todays | MTD | Overall', color: '#fff' },
//   { backgroundColor: '#34c28f', count: '0|0|0', title: 'Conversions - Todays | MTD | Overall', color: '#fff' },
//   { backgroundColor: '#f46969', count: '0|0|0', title: 'Rejected - Todays | MTD | Overall', color: '#fff' },
//   { backgroundColor: '#50a5f0', count: '0|0|0', title: 'Follow - Ups Pending - Todays | MTD | Overall', color: '#fff' },
//   { backgroundColor: '#353a40', count: '0|0|0', title: 'Run Rate - Current RR | Required RR', color: '#fff' }

// ]
// let machineId = localStorage.getItem('MachineId')

// if (!machineId) {
//     machineId = crypto.randomUUID()
//     localStorage.setItem('MachineId', machineId)
// }

// const clientDetails = [
//   { title: "Total Pending Leads Count", count: 0 },
//   { title: "Unique Client Count", count: 0 },
//   { title: "Total Dormant Leads", count: 0 },
//   { title: "Total Dormant Unique Clients", count: 0 },
//   { title: "Total Completed Leads", count: 0 },
// ]

// const clientTypeSplit = [
//   { title: "Escalated Clients", count: 0 },
//   { title: "Only Engagement Client", count: 0 },
//   { title: "Orange Clients", count: 0 },
//   { title: "Green Clients", count: 0 },
//   { title: "Blue Clients", count: 0 },
// ]

// const deliverableCount = [
//   { title: "0 Deliverable Pending", count: 0 },
//   { title: "1 Deliverable Pending", count: 0 },
//   { title: "2 Deliverable Pending", count: 0 },
//   { title: "3 Deliverable Pending", count: 0 },
//   { title: ">3 Deliverable Pending", count: 0 },
// ]

// const followupReport = [
//   { title: "Today's Followup Count", count: 0 },
//   { title: "Yesterday's Followup Count", count: 0 },
//   { title: "Average Followup Per Day (Last 7 Days)", count: 0 },
//   { title: "Average Followup Per Day (Last 30 Days)", count: 0 },
//   { title: "Average Followup Per Day (Last 60 Days)", count: 0 },
//   { title: "Lead Count Without Followup", count: 0 },
//   { title: "Total Future Followup Count", count: 0 },
//   { title: "Total No Of Aging Followup", count: 0 },
//   { title: "Highest Aging", count: 0 },
//   { title: "On Time Followup Completion % (Last 30 Days)", count: 0 },
// ]
// const cardStyles = [
//   { backgroundColor: "#0D70E2", color: "#fff" }, // Client Details
//   { backgroundColor: "#f1b54c", color: "#fff" }, // Client Type Split
//   { backgroundColor: "#34c28f", color: "#fff" }, // Deliverable Count
// ]


// const rowStyle = {
//   display: "flex",
//   justifyContent: "space-between",
//   borderBottom: "1px solid #ddd",
//   padding: "5px 0",
//   fontSize: "14px",
// }
// const firstColumnData = [
//   "Album Selection", "Frame Selection", "Retouch Selection", "CV Song Selection", "Montage Song Confirmation",
//   "Album Print", "Magazine Print Confirmation", "Frame Print Confirmation", "Address Followup", "Data Changes",
//   "Product Upselling", "Product Feedback", "Dormant Closure", "Client Referral"
// ]

// const secondColumnData = [
//   "Total Albums - Client Pending", "Total Frames - Client Pending", "Total Retouch - Client Pending", "Total CV - Client Pending",
//   "Total Montage - Client Pending", "Total Albums - Print Confirmation Pending", "Total Magazine - Print Confirmation Pending",
//   "Total Frame - Print Confirmation Pending", "Total Dispatch Pending", "Overall Data Changes", "Overall Product Upselling",
//   "Overall Product Feedback", "Total Pending Leads > 180 Days", "Overall Client Referral"
// ]

// // const columns = [
// //   {
// //     text: "S.No",
// //     dataField: "sNo",
// //     headerStyle: { minWidth: "60px" }
// //   },
// //   {
// //     text: "Lead Number",
// //     dataField: "leadNumber",
// //     headerStyle: { minWidth: "120px" }
// //   },
// //   {
// //     text: "Bride Name",
// //     dataField: "brideName",
// //     headerStyle: { minWidth: "150px" }
// //   },
// //   {
// //     text: "Groom Name",
// //     dataField: "groomName",
// //     headerStyle: { minWidth: "150px" }
// //   },
// //   {
// //     text: "Future Followup Date",
// //     dataField: "futureFollowupDate",
// //     headerStyle: { minWidth: "170px" }
// //   },
// //   {
// //     text: "Future Followup Remarks",
// //     dataField: "futureFollowupRemarks",
// //     headerStyle: { minWidth: "200px" }
// //   },
// //   {
// //     text: "Previous Followup Date",
// //     dataField: "previousFollowupDate",
// //     headerStyle: { minWidth: "200px" }
// //   },
// //   {
// //     text: "Aging Date",
// //     dataField: "agingDate",
// //     headerStyle: { minWidth: "140px" }
// //   },
// // ]

// // const clientColumns = [
// //   {
// //     text: "S.No",
// //     dataField: "sNo",
// //     headerStyle: { minWidth: "80px" }
// //   },
// //   {
// //     text: "Lead Number",
// //     dataField: "leadNumber",
// //     headerStyle: { minWidth: "120px" }
// //   },
// //   {
// //     text: "Bride Name",
// //     dataField: "brideName",
// //     headerStyle: { minWidth: "150px" }
// //   },
// //   {
// //     text: "Groom Name",
// //     dataField: "groomName",
// //     headerStyle: { minWidth: "150px" }
// //   },
// //   {
// //     text: "Event Date",
// //     dataField: "eventDate",
// //     headerStyle: { minWidth: "130px" }
// //   },
// //   {
// //     text: "Event Name",
// //     dataField: "eventName",
// //     headerStyle: { minWidth: "160px" }
// //   },
// //   {
// //     text: "Total Deliverable Count",
// //     dataField: "totalDeliverableCount",
// //     headerStyle: { minWidth: "210px" }
// //   },
// //   {
// //     text: "Pending Deliverable Count",
// //     dataField: "pendingDeliverableCount",
// //     headerStyle: { minWidth: "220px" }
// //   }
// // ]

// // pagination options
// const options = {
//   sizePerPage: 5,
//   custom: true,
//   pageStartIndex: 1,
//   firstPageText: "First",
//   nextPageText: "Next",
//   lastPageText: "Last",
//   nextPageTitle: "First page",
//   firstPageTitle: "Next page",
//   lastPageTitle: "Last page",
//   showTotal: true,
// }
// console.log(deviceId, "deviceId")
//const simpleValidator = useRef(new SimpleReactValidator())
class Dashboard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      reports: [
        { title: "Orders", iconClass: "bx-copy-alt", description: "1,235" },
        {
          title: "Revenue",
          iconClass: "bx-archive-in",
          description: "$35, 723",
        },
        {
          title: "Average Price",
          iconClass: "bx-purchase-tag-alt",
          description: "$16.2",
        },
      ],
      email: [
        { title: "Week", linkto: "#", isActive: false },
        { title: "Month", linkto: "#", isActive: false },
        { title: "Year", linkto: "#", isActive: true },
      ],
      modal: false,
      subscribemodal: false,
      chartSeries: [],
      periodType: "yearly",
      openModal: false,
      input: {},
      errors: {},

      //newPassword: "",
      //confirmPassword: "",
    }

    this.togglemodal.bind(this)
    this.togglesubscribemodal.bind(this)
    this.handleModal.bind(this)
    this.handleChange.bind(this)
    this.onchangeValidate.bind(this)
  }


  componentDidMount() {
    const { onGetChartsData } = this.props
 
    //setTimeout(() => this.setState({ subscribemodal: true }), 2000)
    onGetChartsData("yearly")
   
    //const {session} = this.props
    // console.log("session is", this.props.session)
    const isDefault = this.props.session.user.isDefaultPassword
    
    if (isDefault === 1) {
      this.setState({ openModal: true })
    } else {
      this.setState({ openModal: false })

    }

  }


  togglemodal = () => {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }))
  }

  togglesubscribemodal = () => {
    this.setState(prevState => ({
      subscribemodal: !prevState.subscribemodal,
    }))
  }

  handleModal = () => {
    const _id = this.props.session.user.id
    const reset_Password = {
      employeeId: _id,
      newPassword: this.state.input.newPassword
    }
    if (this.validate()) {
      let input = {}
      input["newPassword"] = ""
      input["confirmPassword"] = ""
      this.setState({ input: input })
      this.props.resetPassword(reset_Password)
      setTimeout(() => {
        alert('Your Password has been resetted successfully')
      }, 2000)
      this.setState({ openModal: false })
    }
    //this.props.resetPassword(reset_Password)
    // console.log(reset_Password, "resetpassword is")
  }

  handleChange = (e) => {
    let input = this.state.input
    input[e.target.name] = e.target.value

    this.setState({
      input
    })
    //this.setState({ ...this.state, [e.target.name]: e.target.value })
 
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({ ...this.state, chartSeries: this.props.chartsData })
    }
    // console.log("chartsdata", this.props.chartsData)
  }

  validate() {
    let input = this.state.input
    let errors = {}
    let isValid = true

    if (!input["newPassword"]) {
      isValid = false
      errors["newPassword"] = "Please Enter your New Password."
    }
    if (!input["confirmPassword"]) {
      isValid = false
      errors["confirmPassword"] = "Please Enter your Confirm Password."
    }


    // if (typeof input["newPassword"] !== "undefined" && typeof input["confirm_Password"] !== "undefined") {

    if (input["newPassword"] != input["confirmPassword"]) {
      isValid = false
      errors["confirmPassword"] = "Confirm password is Not Matched"
    }
    // }

    this.setState({
      errors: errors
    })

    return isValid
  }

  onchangeValidate() {
    let input = this.state.input
    let errors = {}
    let isValid = true
    if (input["newPassword"]) {
      isValid = false
      errors["newPassword"] = ""
    }
    if (input["confirmPassword"]) {
      isValid = false
      errors["confirmPassword"] = ""
    }

    this.setState({
      errors: errors
    })

    return isValid
  }

  render() {
    const authUser = localStorage.getItem("authUser")
    const crmLoginVal = authUser ? JSON.parse(authUser) : null
    const crmLogin = crmLoginVal?.userType 
   
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Dashboard | Zero Gravity CRM</title>
          </MetaTags>
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs
              title={this.props.t("Dashboards")}
              breadcrumbItem={this.props.t("Dashboard")}
            />
            {(this.props.session?.user?.userType === "CRM" || crmLogin === "CRM") &&(
              <CrmDashBoard />
            )}
            {/* {crmLogin === true ? (
             
            ) : ("")} */}
 
            {/* <Row>


              <Card>
                <CardBody>
                  <Col md={12}>

                   Counter Start 
                    <Col xs={12}>
                      <Row style={{ alignItems: 'center' }}>

                        {/* {CardOject.map((data, key) => (
                          <Col lg={2} key={key}>
                            <Card style={{ backgroundColor: data.backgroundColor }} className="text-white-50 cardStyle" >
                              <CardBody>
                                <h4 style={{ color: data.color }}>{data.count}</h4>
                                <h6 style={{ color: data.color }}>{data.title}</h6>
                              </CardBody>
                            </Card>
                          </Col>
                        ))} 


                      </Row>
                    </Col>
                   Counter End *

                  </Col>
                </CardBody>
              </Card>
            </Row> */}
            {this.state.openModal && (
              <Modal show={this.state.openModal} backdrop="static"
                keyboard={false}>
                <Modal.Header
                  style={{
                    backgroundColor: "#E40D8C",
                    color: "white",
                    minHeight: "65px",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  <div> Reset Default Password </div>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col sm="12" xs="12" className="mt-2" >
                      <Label className="employee-label">
                        New Password
                      </Label><Input
                        type="text"
                        name="newPassword"
                        value={this.state.input.newPassword}
                        onChange={(e) => {
                          {
                            this.handleChange(e)
                            this.onchangeValidate()
                          }
                        }
                        }
                        placeholder="Enter New Password"
                      />
                      <div className="text-danger">{this.state.errors.newPassword}</div>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="12" xs="12" className="mt-2" >
                      <Label className="employee-label">
                        Confirm Password
                      </Label><Input
                        type="text"
                        name="confirmPassword"
                        value={this.state.input.confirmPassword}
                        onChange={(e) => {
                          {
                            this.handleChange(e)
                            this.onchangeValidate()
                          }
                        }
                        }
                        placeholder="Enter Confirm Password"
                      />
                      <div className="text-danger">{this.state.errors.confirmPassword}</div>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    className="btn btn-success"
                    onClick={() => { this.handleModal() }}
                  >
                    Reset Password
                  </Button>
                  <Button
                    variant="primary"
                    className="btn btn-danger"
                    onClick={() => {
                      // this.setState({ openModal: false })
                      toast.success("Logout successfully")
                    }}
                  >
                    <Link to="/logout" style={{ color: "#ffffff" }}>
                      <span>{this.props.t("Cancel")}</span>
                    </Link>
                  </Button>
                </Modal.Footer>
              </Modal>
            )}

          </Container>
        </div>
      </React.Fragment>
    )
  }
}

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
  dispatch: PropTypes.func,
  //user:PropTypes.any,
  //success:PropTypes.any
  session: PropTypes.object,
  resetPassword: PropTypes.func,
  sessionUpdate: PropTypes.any
}

const mapStateToProps = state => {

  return {
    session: state.session,
    sessionUpdate: state.session,
   // login:state.
    //  chartsData: Dashboard.chartsData,
  }

}

const mapDispatchToProps = dispatch => ({
  onGetChartsData: (periodType) => dispatch(getChartsData(periodType)),
  resetPassword: (reset_Password) => dispatch(resetPassword(reset_Password)),

})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Dashboard))
)

